import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import NotificationDropdown from 'components/notifications/NotificationDropdown';
import WebsocketsContainer from 'containers/websockets/WebsocketsContainer';

import {readAllNotificationsAlert, removeAllNotificationsAlert, removeNotificationAlert} from 'modules/notifications';

import 'style/containers/notifications/notification-dropdown.scss';

/** Component to render a dropdown with all the notifications */
class NotificationDropdownContainer extends Component {

    static propTypes = {
        notifications: PropTypes.array // Array with all the notifications to show
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handleRemove = this.handleRemove.bind(this);
        this.handleRemoveAll = this.handleRemoveAll.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    /**
     * Remove the passed notification
     * @param {Object} notification The notification object to remove
     */
    handleRemove(notification) {
        const {dispatch} = this.props;

        dispatch(removeNotificationAlert(notification.id));
    }

    /**
     * Remove all of notifications
     */
    handleRemoveAll() {
        const {dispatch} = this.props;

        dispatch(removeAllNotificationsAlert());
    }

    /**
     * Set as read all of notifications
     */
    handleClose() {
        const {dispatch} = this.props;

        dispatch(readAllNotificationsAlert());
    }

    handleDownload(e, url) {

        window.location.href = url;
    }


    render() {
        const {notifications} = this.props;

        return (
            <div>
                <NotificationDropdown
                    notifications={notifications}
                    onRemove={this.handleRemove}
                    onRemoveAll={this.handleRemoveAll}
                    onClose={this.handleClose}
                    onDownload={this.handleDownload}
                />
                <WebsocketsContainer/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    notifications: state.notifications.notifications
});

export default injectIntl(connect(mapStateToProps)(NotificationDropdownContainer));



// WEBPACK FOOTER //
// ./src/containers/notifications/NotificationDropdownContainer.jsx